<template>
    <div class="modal-background">
        <div v-show="!isResultView">
            <div class="modal-card pt-6">
                <header class="modal-card-head">
                    <p class="modal-card-title">Status Repair</p>
                    <button class="delete is-medium" @click="close()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <div class="content">
                        <p> Backfill message statuses for a Customer Line. This tool updates all messages for a line that are in the "Sending" status. </p>
                        <p> <i>(Currently only compatible with Zipwhip)</i> </p>
                    </div>
                    <label class="label">Line Id</label>
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <input class="input" type="text" placeholder="Line id..." v-model="lineId">
                        </div>
                        <CustomerLineDropdown @lineSelected="lineSelected" />
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button :class="isLoading ? 'button is-primary is-loading' : 'button is-primary'" :disabled="!isValid"
                        @click="queueRepair()">Queue Repair</button>
                    <button class="button is-primary" @click="close()">Cancel</button>
                </footer>
            </div>
        </div>
        <div v-show="isResultView">
            <div class="modal-card pt-6">
                <header class="modal-card-head">
                    <p class="modal-card-title">Result</p>
                    <button class="delete is-medium" @click="close()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <div class="message is-success">
                        <div class="message-header">
                            <p>Success</p>
                        </div>
                        <div class="message-body">
                            <p>Status repair job has been queued.</p>
                            <p>Job Id: {{ jobId }}</p>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <button class="button is-primary" @click="closeResults()">Repair Another Line</button>
                    <button class="button is-primary" @click="close()">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import { securePost } from '../../secureFetch.js';
import CustomerLineDropdown from '../CustomerLineDropdown';

export default {
    name: "StatusRepairModal",
    components: { CustomerLineDropdown },
    computed: {
        hostUrl: function () {
            return this.$store.state.hostUrl;
        },
        isValid: function () {
            return (this.lineId && this.lineId.trim() !== "");
        },
    },
    data() {
        return {
            lineId: null,
            isLoading: false,
            isResultView: false,
            errorMessage: null,
            jobId: null,
        };
    },
    mounted() {
    },
    methods: {
        close() {
            this.lineId = null;
            this.isLoading = false;
            this.isResultView = false;
            this.errorMessage = null;
            this.jobId = null;
            this.$emit("close");
        },
        closeResults() {
            this.lineId = null;
            this.isResultView = false;
            this.errorMessage = null;
            this.jobId = null;
        },
        lineSelected(lineId) {
            this.lineId = lineId;
        },
        async queueRepair() {
            this.isLoading = true;

            var postBody = {
                lineId: this.lineId,
            };

            const result = await securePost(this.hostUrl + "v1/utilityjob/queue-status-repair", postBody);

            this.isLoading = false;

            if (result != null && result.success) {
                this.jobId = result.jobId;
                this.isResultView = true;
            }
            else {
                this.$buefy.toast.open({
                    duration: 5000,
                    message: `${result.message ? "Error: " + result.message : "Something went wrong."}`,
                    position: 'is-bottom',
                    type: 'is-danger',
                })
            }
        },
    },
};
</script>

<style scoped>
.modal-card {
    overflow: visible;
    max-width: 820px;
    width: fit-content;
}

.modal-card-body {
    overflow: visible;
    max-width: 780px;
    width: fit-content;
}

.list {
    padding: 0;
    margin-top: 0;
    margin-bottom: 0;
}

.list-item {
    margin: 0;
}
</style>